import styles from "./style.module.scss";

import DynamicForm from "@mavichpe/dynamic-forms";
import SendBackupToEmailFormConfig from "./form";
import { useEffect, useState } from "react";
import { SendDocumentDataType } from "@/formTypes/SendDocumentDataType";
import LoadingScreen from "@components/content/LoadingScreen";
import { showAlert } from "@utils/Alert";
import { ApiClient } from "@/api/ApiClient";
import { OpenSendBackupToEmailPubSub } from "@utils/pubsubs/PubSub";

type SendBackupToEmailFormProps = {
  defaultData: SendDocumentDataType
}

const SendBackupToEmailForm = (props: SendBackupToEmailFormProps) => {
  const { defaultData } = props;
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
  }, [])

  const onSubmit = async (formData: SendDocumentDataType) => {
    setIsLoading(true);
    try {
      const { data, errors } = await ApiClient.mutations.creatEmailTenantBackupMutation({
        toEmails: `${formData.emails}`.split(","),
        subject: "Respaldo Easypos",
        filenamePrefix: "respaldo_easypos",
      });
      if (errors) throw errors[0];
      if (!data?.ok) throw new Error(data?.error || "Falló el envío");
      showAlert("success", "El respaldo ha sido enviado exitosamente")
      OpenSendBackupToEmailPubSub.publish({
        openOffCanvas: false
      })
    } catch (err) {
      if (err instanceof Error) {
        const errorMessage = err.message || "No fue posible enviar el correo electronico";
        showAlert("danger", errorMessage)
      }
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <>
      <DynamicForm<SendDocumentDataType>
        externalFormState={defaultData}
        formConfig={SendBackupToEmailFormConfig}
        onSubmit={onSubmit}
      >
      </DynamicForm>
      <LoadingScreen isLoading={isLoading} />
    </>

  )
}

export default SendBackupToEmailForm;